import css from '@emotion/css';
import { styled, Heading, textStyle, minimumWidth } from '@feast-it/ui/light';

export const StyledHeading = styled(Heading)(
  ({ theme }) =>
    css`
      text-align: center;
      margin-bottom: ${theme.spacing[4]};
      ${textStyle(theme, 'headingMobileExtraLarge')}

      ${minimumWidth(theme.breakpoints.medium)} {
        ${textStyle(theme, 'headingExtraLarge')}
      }
    `
);

export const RelatedSEOTags = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: ${theme.spacing[4]};
  `
);
